<template>
  <div class="container">
    <div
      v-if="loading"
      style="display: flex; justify-content: center; align-items: center; min-height: 300px"
    >
      <spinner />
    </div>
    <waiting-room
      v-else-if="waitingRoomStatus === 'WAITING_ROOM'"
      :event-title="event ? event.title : ''"
      :position-in-queue="positionInQueue"
      :people-in-front="peopleInFront"
    />
    <event-password-unavailable
      v-else-if="
        scorpionsSaleDisplay === 'presale-unavailable' ||
          (!scorpionsSaleDisplay && event.flags && event.flags.eventPasswords && eventPasswordState === 'upcoming' && !eventPasswordAccepted)
      "
    />
    <event-password-login
      v-else-if="
        !eventPasswordAccepted && (
          scorpionsSaleDisplay === 'presale-password' ||
          (!scorpionsSaleDisplay && event.flags && event.flags.eventPasswords && eventPasswordState === 'active')
        )
      "
      :event-id="event.id"
      @acceptEventPassword="eventPasswordAccepted = true"
    />
    <div v-else>
      <link v-if="customStyles.stylesheet" rel="stylesheet" :href="customStyles.stylesheet">
      <div>
        <div
          v-if="!showMessage"
          class="grid-container"
          :style="
            event.extraModules.ticketing ? 'justify-content:flex-end' : 'justify-content:center'
          "
        >
          <div v-if="!isZkm && event.cover" class="card-header-with-cover">
            <div class="event-cover">
              <img :src="event.cover" alt="cover image">
            </div>
            <card-header-cover
              v-if="(!isZkm && event.cover) || activeStep !== 1"
              :class="['overflow-card', activeStep !== 1 && 'overflow-card-step-two']"
              :event="event"
              :active-step="activeStep"
            />
            <div
              v-if="
                event &&
                  organizationId &&
                  showPromoCodeInputInRegisterContainer(Number(event.id), organizationId)
              "
              :style="activeStep !== 1 && 'display:none'"
              :class="['promo-code-zkm', 'promo-code-container']"
            >
              <add-promo-code
                ref="addPromoCodeRef"
                :promo-code="promoCode"
                :membership="membership"
                :event="event"
                :initial-promo-code="initialPromoCode"
                :is-zkm="isZkm"
                :order-item-access-code="orderItemAccessCode"
                @applySubscription="applySubscription"
                @removeSubscription="removeSubscription"
                @applyPromoCode="applyPromoCode"
                @applyMembership="handleMembershipClick"
                @removePromoCode="removePromoCodeAndMembership"
                @applyOrderItemAccessCode="applyOrderItemAccessCode"
              />
            </div>
          </div>
          <v-flex v-else>
            <card-header
              ref="cardHeaderRef"
              :style="activeStep !== 1 && 'display:none'"
              :event="event"
              :membership="membership"
              :initial-promo-code="initialPromoCode"
              :promo-code="promoCode"
              :initial-values="shoppingCart"
              :active-step="activeStep"
              :order-item-access-code="orderItemAccessCode"
              @applyPromo="applyPromoCode"
              @removePromoCode="removePromoCode"
              @applyMembership="applyMembership"
              @applySubscription="applySubscription"
              @removeSubscription="removeSubscription"
              @applyMembershipInParent="handleMembershipClick"
              @removeMembership="handleRemoveMembershipZkm"
              @applyOrderItemAccessCode="applyOrderItemAccessCode"
              @removeOrderItemAccessCode="handleRemoveOrderItemAccessCode"
            />
          </v-flex>
          <main
            :class="[
              activeStep !== 1 && 'main-row',
              !event.cover && (isZkm ? 'main-no-image-zkm' : 'main-no-image'),
            ]"
          >
            <become-member-alert
              v-if="showBecomeMemberAlert"
              :message="becomeMemberMessage"
              :organization-slug="organizationSlug"
              @click="showBecomeMemberAlert = false"
            />
            <event-full v-if="isEventFull && !event.canceled" />
            <div v-else-if="isPurchasingUnavailable" class="no-tickets">
              <img :src="getModalImage" alt="no tickets">
              <module-title
                color="#333333"
                :title="getModalTitle"
                :description="getModalDescription"
                :show-events-button="true"
                :show-ticket-swap-button="event.soldOut && !event.canceled"
                :event="event"
                class="pb-4"
              />
              <div
                v-if="event.canceled && event.cancellationNotification"
                class="cancel-notification"
              >
                <div>{{ $t('organizerMessage') }}:</div>
                <div v-html="event.cancellationNotification" />
              </div>
            </div>
            <div
              v-else
              :class="['ticket-list-container', event.cover && 'ticket-list-container-with-cover']"
            >
              <v-alert
                v-if="activeStep === 1 && cinehillPackageTicketsRemaining !== null"
                type="info"
                outlined
                class="mb-4"
              >
                {{ cinehillPackageRemainingMessage(cinehillPackageTicketsRemaining) }}
              </v-alert>
              <div v-if="activeStep === 1 && event.extraModules.ticketing">
                <v-alert
                  v-if="requiredTicketsPerCategory && !event.extraModules.floorPlan"
                  type="info"
                  outlined
                  class="mb-4"
                >
                  {{ categoryTicketRequirementMessage }}
                </v-alert>
                <tickets-list
                  v-if="!event.extraModules.floorPlan"
                  ref="childList"
                  :key="numberOfRemainingTickets"
                  :event="event"
                  :num-of-remaining-tickets="numberOfRemainingTickets"
                  :show-remaining-tickets-chip="showRemainingTicketsChip"
                  :updated-order-items="updatedOrderItems"
                  :initial-promo-code="initialPromoCode"
                  :color="getThemeStyle(event.coverImagePrimaryColor, null, 'primary')"
                  :initial-values="shoppingCart"
                  :show-header="Number(event.id) !== 2532"
                  :membership="membership"
                  :promo-code="promoCode"
                  :order-item-access-code="orderItemAccessCode"
                  :required-tickets-per-category="requiredTicketsPerCategory"
                  :max-packages="maxTicketPackages"
                  @back="
                    form.ticket = $event
                    goBack()
                  "
                  @next="onTicketsSelected($event)"
                  @selectedTickets="selectedTickets"
                  @applyPromo="applyPromoCode"
                  @applyMembership="applyMembership"
                  @removePromoCode="removePromoCode"
                />

                <floor-plan
                  v-else
                  ref="childFloor"
                  :event="event"
                  :updated-order-items="updatedOrderItems"
                  :initial-promo-code="initialPromoCode"
                  :initial-values="shoppingCart"
                  :ticket-locations="ticketLocations"
                  :initial-seat-select="initialSeatSelect"
                  :num-of-remaining-tickets="numberOfRemainingTickets"
                  :show-remaining-tickets-chip="showRemainingTicketsChip"
                  :promo-code="promoCode"
                  :membership="membership"
                  :order-item-access-code="orderItemAccessCode"
                  @applyPromo="applyPromoCode"
                  @applyMembership="applyMembership"
                  @applySubscription="applySubscription"
                  @removePromoCode="removePromoCode"
                  @addSelectedTickets="addSelectedSeat"
                  @removeSelectedTickets="removeSelectedSeat"
                  @removeSelectedTableTickets="removeSelectedTableTickets"
                  @addDialogElementToOrder="addDialogElementToOrder"
                  @back="
                    form.ticket = $event
                    goBack()
                  "
                  @next="onFloorPlanSeatSelect($event)"
                />
              </div>
              <attendee-data
                v-else-if="activeStep === 1"
                :event="event"
                :schema="schema"
                :styles="customStyles.attendeeForm"
                :initial-values="form.attendee"
                @back="
                  form.attendee = $event
                  goBack()
                "
                @next="next($event)"
                @submit="
                  form.attendee = $event
                  submitStepper()
                "
              />
              <attendee-data
                v-if="activeStep === 2 && !event.extraModules.ticketing && customAttendeeFields"
                :event="event"
                :schema="schema"
                :styles="customStyles.attendeeForm"
                :initial-values="form.attendee"
                @back="
                  form.attendee = $event
                  goBack()
                "
                @next="
                  form.attendee = $event
                  purchaseTicket('CreditCard')
                "
                @submit="
                  form.attendee = $event
                  purchaseTicket('CreditCard')
                "
              />
              <checkout-timer
                v-if="
                  event.extraModules.ticketing && shoppingCart.length && activeStep !== 1 && !isZkm
                "
                :start-time="startTime"
                :event="event"
                :class="[
                  !event.cover
                    ? 'checkout-timer-regular-mobile-no-cover'
                    : 'checkout-timer-regular-mobile',
                ]"
              />
              <checkout
                v-if="activeStep === 2 && event.extraModules.ticketing"
                ref="checkoutRef"
                :event="event"
                :schema="schema"
                :styles="customStyles.attendeeForm"
                :initial-values="form.attendee"
                :selected-tickets="shoppingCart"
                :total-order-price="order ? order.price : totalPrice()"
                :ticket-insurance-amount="ticketInsuranceAmount"
                @user="user = $event"
                @back="clearTicketCart()"
                @next="
                  const { paymentType, ...attendeeData } = $event
                  form.attendee = attendeeData
                  purchaseTicket(paymentType)
                "
                @applyGiftCard="applyGiftCard"
                @changeInsurance="ticketsInsurance = $event"
              />
              <user-message-dialog
                :show.sync="showUserMessageDialog"
                :user-message-dialog="userMessageDialog"
              />
              <!--
              <keks-payment
                v-if="activeStep === 3"
                :order="order"
                :event="event"
                @back="activeStep = 2"
              />
              -->
              <workshops-list
                v-if="activeStep === 4"
                ref="workshopsList"
                :event="event"
                :selected="form.workshops"
                :initial-workshops="event.workshops"
                :attendee="form.attendee"
                :styles="customStyles.workshopsForm"
                @back="
                  form.workshops = $event
                  activeStep = event.extraModules.ticketing ? 2 : 1
                "
                @submit="
                  form.workshops = $event
                  event.extraModules.ticketing ? purchaseTicket('') : submitStepper()
                "
              />
            </div>
          </main>
          <aside v-if="event.extraModules.ticketing" class="cover-header-style">
            <checkout-timer
              v-if="
                event.extraModules.ticketing &&
                  shoppingCart.length &&
                  activeStep !== 1 &&
                  !isPurchasingUnavailable
              "
              :start-time="startTime"
              :event="event"
              class="checkout-timer-regular"
            />
            <ticket-price-list
              v-if="
                event.extraModules.ticketing && shoppingCart.length !== 0 && !isPurchasingUnavailable
              "
              ref="ticketPriceList"
              :key="subscription.length"
              :class="[isZkm && shoppingCart.length === 0 && 'cover-header-style-zkm-border']"
              :event="event"
              :membership="membership"
              :start-time="startTime"
              :subscription="subscription"
              :selected-tickets="shoppingCart"
              :cover="event.cover"
              :promo-code="promoCode"
              :ticket-locations="ticketLocations"
              :shopping-cart="shoppingCart"
              :active-step="activeStep"
              :user="user"
              :gift-card="giftCard"
              :selected-ticket-insurance="ticketsInsurance"
              @back="clearTicketCart()"
              @signIn="scrollToLoginOptions"
              @triggerClick="handleClickInChildA()"
              @triggerPayment="handlePaymentClick()"
              @updateTicketInsuranceAmount="ticketInsuranceAmount = $event"
            />
          </aside>
        </div>
        <v-layout v-else justify-center>
          <v-flex
            shrink
            class="registration-success-page"
            :style="Number(event.id) === 2849 && 'margin: 0 !important'"
          >
            <img
              v-if="Number(event.id) === 2849"
              class="info-image"
              src="../../../../public/assets/a1-since-1999-end.jpg"
              alt="mail_successful"
            >
            <img
              v-else
              class="info-image"
              src="../../../../public/assets/mail_success.svg"
              alt="mail_successful"
            >
            <div class="my-page-title">
              <span v-if="customStyles.base && customStyles.base.submitNote">{{
                customStyles.base.submitNote
              }}</span>
              <span v-else>{{ $t('registrationFinish') }}</span>
            </div>
            <div v-if="customStyles.base && customStyles.base.submitInfo" class="description">
              {{ customStyles.base.submitInfo }}
            </div>
            <div v-else class="description">
              {{ Number(event.id) === 3710 ? '' : $t('registrationDescription') }}
            </div>
            <img
              v-if="[4531,8265].includes(Number(event.id))"
              src="https://s3.eu-central-1.amazonaws.com/accreditationmanager/ungrouped/275a5e82-c085-4b86-9935-48231b4edbe0"
              style="max-width: 15rem"
            >
            <div v-if="![2849, 3148, 3710].includes(Number(event.id))" class="mt-12 text-center">
              <main-button
                :text="(customStyles.base && customStyles.base.addAnother) || $t('addAttendee')"
                @click="addAnother"
              />
            </div>
          </v-flex>
        </v-layout>
        <simple-snackbar :open.sync="showError" color="primary" :message-prop="snackbarMessage" />
      </div>
      <simple-snackbar
        :open.sync="snackbarOpen"
        :message-prop="errorMessage"
        :timeout="[2444, 4531, 8265].includes(Number(event.id)) ? 15000 : 4000"
        color="error"
      />
    </div>
  </div>
</template>

<script>
import {
  CHECK_IF_ATTENDEE_ALREADY_EXISTS,
  GET_EVENT_ADDITIONAL_DATA_FOR_REGISTER_CONTAINER,
  GET_EVENT_ATTENDEE_CAPACITY,
  GET_EVENT_DETAILS_FOR_REGISTER_CONTAINER,
  GET_EVENT_DYNAMIC_DATA,
  GET_EVENT_NUM_OF_REMAINING_TICKETS,
  GET_WORKSHOP_DETAILS_BY_EVENT_SLUG,
} from '@/graphql/event.graphql'

import CardHeader from '../../shared/card-header.vue'
import Spinner from './../../shared/spinner.vue'
import AttendeeData from '../register-stepper/attendee-data.vue'
import WorkshopsList from '../register-stepper/workshops-list.vue'
import TicketsList from '../register-stepper/tickets-list.vue'
import CheckoutTimer from '../register-stepper/checkout-timer.vue'
import { isRevolutCheckoutActive } from '@/revolut-checkout-state'
import {
  createFloorPlanPurchaseAccreditationsPublic,
  createPendingAccreditationPublic,
  createPurchaseAccreditationsPublic,
  fetchSelectedSeatsByOrderUUID,
  getPromoCodeByName,
  getOrderInfoByUUID,
  populateOrderData,
  getKiPaymentRedirectUrl,
} from '@/http'
import SimpleSnackbar from '../../shared/snackbars/simple-snackbar.vue'
import {
  createAttendeeSchema,
  createPurchaseCheckout,
  getIOSVersion,
  initializeRegisterForm,
  showPromoCodeInputInRegisterContainer,
  startPaymentCheckout,
  submitGuard,
} from '@/utils'
import CardHeaderCover from '../../shared/card-header-cover.vue'
import TicketPriceList from '../register-stepper/ticket-price-list.vue'
import Checkout from '../register-stepper/checkout.vue'
import FloorPlan from '../register-stepper/floor-plan.vue'
import moment from 'moment'
import i18next from 'i18next'
import AddPromoCode from '@/components/tickets/add-promo-code.vue'
import { TicketType } from '@/types'
import ModuleTitle from '@/components/shared/module-title.vue'
import EventPasswordLogin from '@/components/accreditations/event-password-login.vue'
import EventPasswordUnavailable from '@/components/accreditations/event-password-unavailable.vue'
import { getEventPasswordState } from '@/utils/event-passwords'
import { getScorpionsSaleDisplay } from '@/utils/scorpions-sale'
import UserMessageDialog from '@/components/accreditations/register-stepper/user-message-dialog.vue'
import axios from 'axios'
import BecomeMemberAlert from '@/components/tickets/become-member-alert.vue'
import { serverURL } from '../../../utils'
import WaitingRoom from './waiting-room.vue'
import EventFull from './event-full.vue'
import {
  sendOrganizationFacebookPageView,
  sendOrganizationFacebookPixelEvent,
} from '@/services/fbmeta.service'
import ticketPackageRules from '../../../../../backend/server/ticket-package-rules.json'
import { evaluateCategoryTicketPackages } from './category-ticket-packages'

const BUYER_FIELD_KEYS_WITH_PERSONALIZATION = [
  'First name',
  'Last name',
  'Email',
  'Address',
  'City',
  'Postal code',
  'Country',
]

export default {
  name: 'register',
  components: {
    WaitingRoom,
    EventFull,
    UserMessageDialog,
    EventPasswordLogin,
    EventPasswordUnavailable,
    ModuleTitle,
    AddPromoCode,
    Spinner,
    WorkshopsList,
    CardHeader,
    AttendeeData,
    SimpleSnackbar,
    TicketsList,
    CardHeaderCover,
    TicketPriceList,
    Checkout,
    FloorPlan,
    CheckoutTimer,
    BecomeMemberAlert,
  },
  props: {
    eventSlug: {
      type: String,
      default: null,
    },
    status: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    showMessage: false,
    activeStep: 1,
    event: null,
    form: {
      attendee: {},
      workshops: [],
    },
    showError: false,
    initialSeatSelect: null,
    customStyles: {},
    schema: {},
    updatedOrderItems: {},
    userMessageDialog: {},
    initialPromoCode: null,
    snackbarOpen: false,
    showUserMessageDialog: false,
    errorMessage: '',
    customAttendeeFields: false,
    snackbarMessage: '',
    ticketLocations: {},
    initialAttendee: {},
    coverColor: {},
    numberOfRemainingTickets: 0,
    backgroundCoverColor: {},
    shoppingCart: [],
    promoCode: null,
    membership: null,
    subscription: [],
    order: null,
    startTime: null,
    removeSeat: [],
    user: null,
    giftCard: null,
    eventPasswordAccepted: false,
    isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    useEmailLogin: false,
    eventPasswordState: 'open',
    saleDisplayCheckedAt: Date.now(),
    orderItemAccessCode: null,
    isEventUnavailable: true,
    hasNoRemainingTickets: false,
    loadingDetails: true,
    loadingAdditionalData: true,
    loadingDynamicData: true,
    isWaitingRoomCheckInProgress: true,
    waitingRoomStatus: null,
    guestId: null,
    pollingInterval: null,
    positionInQueue: null,
    peopleInFront: null,
    checkoutHeartbeatInterval: null,
    requestTimeout: null,
    showBecomeMemberAlert: false,
    becomeMemberMessage: '',
    autoPromoCodeInProgress: false,
    ticketsInsurance: false,
    ticketInsuranceAmount: null,
    organizationPageViewSent: false,
  }),

  computed: {
    scorpionsSaleDisplay() {
      return getScorpionsSaleDisplay(this.eventSlug, this.$route.query.sale, this.saleDisplayCheckedAt)
    },
    referralName() {
      return this.$route.query.ref
    },
    organization() {
      return (this.event && this.event.organization) || null
    },
    organizationId() {
      return Number(
        (this.organization && this.organization.id) || (this.event && this.event.organizationId),
      )
    },
    organizationSlug() {
      return (this.organization && this.organization.slug) || ''
    },
    ticketPackageConfig() {
      const config = this.event && ticketPackageRules.events[this.event.id]
      if (!config || !Number.isInteger(config.ticketsPerCategory) || config.ticketsPerCategory < 1) {
        return null
      }

      return {
        ticketsPerCategory: config.ticketsPerCategory,
        maxPackages:
          Number.isInteger(config.maxPackages) && config.maxPackages > 0
            ? config.maxPackages
            : ticketPackageRules.defaultMaxPackages,
      }
    },
    requiredTicketsPerCategory() {
      return this.ticketPackageConfig ? this.ticketPackageConfig.ticketsPerCategory : null
    },
    maxTicketPackages() {
      return this.ticketPackageConfig
        ? this.ticketPackageConfig.maxPackages
        : ticketPackageRules.defaultMaxPackages
    },
    categoryTicketRequirementMessage() {
      return this.$t('categoryTicketRequirement', {
        count: this.requiredTicketsPerCategory,
        maxPackages: this.maxTicketPackages,
      })
    },
    isZkm() {
      return this.organizationId == process.env.VUE_APP_ZKM_ORGANIZATION_ID
    },
    showRemainingTicketsChip() {
      return this.organizationId === 677
    },
    hasTicketPersonalization() {
      return !!(
        this.event &&
        this.event.extraModules &&
        this.event.extraModules.ticketPersonalization
      )
    },
    isAutoPromoCodeEvent() {
      return this.organizationId === 625
    },
    cinehillPackageTicketsRemaining() {
      if (!this.promoCode || typeof this.promoCode.remainingTickets !== 'number') {
        return null
      }

      return this.promoCode.remainingTickets
    },
    // a buyer's own unpaid order is already counted against capacity, so a zero
    // remaining count must not lock them out of paying for the tickets they hold
    isPurchasingUnavailable() {
      const hasActiveOrder = !!this.order && this.activeStep !== 1

      return this.scorpionsSaleDisplay === 'general-unavailable' ||
        this.isEventUnavailable || (this.hasNoRemainingTickets && !hasActiveOrder)
    },
    isEventFull() {
      const { extraModules, attendeeLimit, registeredAttendeesCount } = this.event || {}

      return (
        !!extraModules &&
        !extraModules.ticketing &&
        !!attendeeLimit &&
        registeredAttendeesCount >= attendeeLimit
      )
    },
    getModalTitle() {
      if (this.event.canceled) {
        return this.$t('eventCanceled')
      }

      if (this.event.soldOut) {
        return this.$t('ticketSoldOut')
      }

      return this.$t('ticketUnavailable')
    },
    getModalDescription() {
      if (this.event.canceled) {
        if (Number(this.event.id) === 3375) {
          return ''
        }

        return this.$t('eventCanceledDescription')
      }

      if (this.event.soldOut) {
        return this.$t('ticketSoldOutDescription')
      }

      if (this.organizationId === 502) {
        return ''
      }

      return this.$t('ticketUnavailableDescription')
    },
    getModalImage() {
      if (this.event.canceled) {
        return '/assets/sad-ticket.svg'
      }

      if (this.event.soldOut) {
        return '/assets/sad-ticket.svg'
      }

      return '/assets/dont-know-ticket.svg'
    },
    loading() {
      return (
        this.isWaitingRoomCheckInProgress ||
        this.loadingDetails ||
        this.loadingAdditionalData ||
        this.loadingDynamicData
      )
    },
  },
  watch: {
    '$route.query.sale'() {
      if (this.scorpionsSaleDisplay) {
        this.eventPasswordAccepted = false
        this.saleDisplayCheckedAt = Date.now()
      }
    },
    'shoppingCart.length': {
      immediate: true,
      handler() {
        this.handleAutoPromoCodeForOrganization625()
      },
    },
    isAutoPromoCodeEvent() {
      this.handleAutoPromoCodeForOrganization625()
    },
  },
  mounted() {
    window.addEventListener('pagehide', this.handlePageHide)
    // remove this redirect when event is over
    if (this.eventSlug === 'maci-gray-u-tvornici-kulture-f097') {
      window.location.replace(
        'https://app.core-event.co/events/macy-gray-u-tvornici-kulture-f097/register',
      )
    }
    if (this.eventSlug === 'krule-u-zagrebu-novi-termin-70f3') {
      window.location.replace(
        'https://app.core-event.co/events/stand-up-bloger-krule-kino-sc-zagreb-70f3/register',
      )
    }
    if (this.eventSlug === 'kk-dinamo-zagreb-godisnja-ulaznica-sezona-2025-2026-0d88') {
      window.location.replace(
        'https://app.core-event.co/organization/kk-dinamo-zagreb-b746/sport-subscriptions-store',
      )
    }
    if (
      this.eventSlug ===
      '𝐄-𝐂-𝐋-𝐈-𝐏-𝐒-𝐄-𝐗-𝐄-𝐍-��-𝐑-𝐆-𝐄-𝐓-𝐈-𝐂-𝐀-𝐂-𝐥-𝐮-𝐛-𝐂-𝐫-𝐤-𝐯-𝐚-𝟎-𝟒-𝟏-𝟎-𝟐-𝟎-𝟐-𝟓-07ad'
    ) {
      window.location.replace(
        'https://app.core-event.co/events/𝐄-𝐂-𝐋-𝐈-𝐏-𝐒-𝐄-𝐗-𝐄-𝐍-𝐄-𝐑-𝐆-𝐄-𝐓-𝐈-𝐂-𝐀-𝐂-𝐥-𝐮-𝐛-𝐂-𝐫-𝐤-𝐯-𝐚-𝟎-𝟒-𝟏-𝟎-𝟐-𝟎-𝟐-𝟓-07ad/register',
      )
    }
    if (this.eventSlug === '𝐂-𝐇-𝐑-𝐈-𝐒-𝐓-𝐈-𝐀-𝐍-𝐒-��-𝐈-𝐓-𝐇-𝐚-𝐭-𝐂-𝐫-𝐤-𝐯-𝐚-𝐂-𝐥-𝐮-𝐛-▲-5ffb') {
      window.location.replace(
        'https://app.core-event.co/events/𝐂-𝐇-𝐑-𝐈-𝐒-𝐓-𝐈-𝐀-𝐍-𝐒-𝐌-𝐈-𝐓-𝐇-𝐚-𝐭-𝐂-𝐫-𝐤-𝐯-𝐚-𝐂-𝐥-𝐮-𝐛-▲-5ffb/register',
      )
    }
    if (this.eventSlug === 'spic-krilo-beb5') {
      const languageCode = this.getLanguageCodeFromQueryParams()

      window.location.replace(
        `https://app.core-event.co/events/detour-slowcured-spic-krilo-aquarius-zagreb-beb5/register${
          languageCode ? `?lang=${languageCode}` : ''
        }`,
      )
    }
    if (
      this.eventSlug === 'fontaines-dc-na-salati-69f6' &&
      Date.now() >= new Date('2026-10-30T12:30:00+01:00').getTime()
    ) {
      const languageCode = this.getLanguageCodeFromQueryParams()

      window.location.replace(
        `https://app.core-event.co/events/fontaines-dc-u-zagrebu-62e5/register${
          languageCode ? `?lang=${languageCode}` : ''
        }`,
      )
    }
    if (this.eventSlug === 'dani-zagorskih-maturanata-2026-b27a') {
      window.location.replace('https://app.core-event.co/404')
    }
    this.requestTimeout = setTimeout(() => {
      if (this.loadingDetails) {
        this.waitingRoomStatus = 'WAITING_ROOM'
        this.loadingDetails = false
        this.loadingAdditionalData = false
        this.loadingDynamicData = false
        this.isWaitingRoomCheckInProgress = false
      }
    }, 10000)
  },
  apollo: {
    getEventBasicData: {
      query: GET_EVENT_DYNAMIC_DATA,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          slug: this.eventSlug,
        }
      },
      skip() {
        return (
          this.isWaitingRoomCheckInProgress ||
          this.waitingRoomStatus === 'WAITING_ROOM' ||
          !this.eventSlug
        )
      },
      async result({ loading, data }) {
        if (!loading && data) {
          const { getEventBasicData: event } = data
          this.event = { ...this.event, ...event }

          //close applications 30 minutes before event starts for organization with id 602 (Kino Urania)
          const eventStartsIn30Minutes = moment(this.event.from).diff(moment(), 'minutes') <= 30
          if (Number(event.organizationId) === 602 && eventStartsIn30Minutes) {
            this.event.applicationsOpen = false
            this.loadingDynamicData = false

            return
          }

          this.isEventUnavailable =
            event.soldOut || event.canceled || !event.applicationsOpen || moment().isAfter(event.to)
          this.customAttendeeFields = event.flags && event.flags.customAttendeeFields
          this.schema = createAttendeeSchema(event.attendeeFields)

          this.eventPasswordState = getEventPasswordState(this.event.eventPasswords || [])
          this.saleDisplayCheckedAt = Date.now()

          this.loadingDynamicData = false
        }
      },
    },
    // Not response-cached on the backend, so the attendee count is current after each registration
    getEventAttendeeCapacity: {
      query: GET_EVENT_ATTENDEE_CAPACITY,
      fetchPolicy: 'network-only',
      variables() {
        return {
          slug: this.eventSlug,
        }
      },
      // Only non-ticketed events have an attendee limit, so ticket sales (and waiting rooms) never run this count
      skip() {
        const extraModules = this.event && this.event.extraModules

        return !this.eventSlug || !extraModules || extraModules.ticketing
      },
      result({ loading, data }) {
        if (!loading && data) {
          const { getEventAttendeeCapacity: capacity } = data
          this.event = { ...this.event, ...capacity }
        }
      },
    },
    getEventDetailsForRegisterContainer: {
      query: GET_EVENT_DETAILS_FOR_REGISTER_CONTAINER,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          slug: this.eventSlug,
        }
      },
      skip() {
        return !this.eventSlug
      },
      async result({ loading, data }) {
        if (this.requestTimeout) {
          clearTimeout(this.requestTimeout)
        }
        if (!loading && data) {
          const { getEventDetailsForRegisterContainer: event } = data
          this.event = { ...this.event, ...event }
          this.loadingDetails = false
          await this.handleWaitingRoomCheck()
        }
      },
      error(error) {
        if (this.requestTimeout) {
          clearTimeout(this.requestTimeout)
        }
        console.error('Error fetching event details, entering waiting room:', error)
        // If the initial event details fetch fails, we go into a "passive" waiting room state
        this.waitingRoomStatus = 'WAITING_ROOM'
        this.loadingDetails = false
        this.loadingAdditionalData = false
        this.loadingDynamicData = false
        this.isWaitingRoomCheckInProgress = false
      },
    },
    getEventAdditionalDataForRegisterContainer: {
      query: GET_EVENT_ADDITIONAL_DATA_FOR_REGISTER_CONTAINER,
      fetchPolicy: 'cache-first',
      variables() {
        return {
          slug: this.eventSlug,
        }
      },
      skip() {
        return (
          this.isWaitingRoomCheckInProgress ||
          this.waitingRoomStatus === 'WAITING_ROOM' ||
          !this.eventSlug
        )
      },
      async result({ loading, data }) {
        if (!loading && data) {
          const { getEventAdditionalDataForRegisterContainer: event } = data
          this.event = { ...this.event, ...event }
          this.customStyles = (event.eventUtils && event.eventUtils.inviteFormStyles) || {}
          this.sendOrganizationPageView()

          if (this.event.translation) {
            for (const translation in this.event.translation.translationsJSON) {
              i18next.addResourceBundle(
                translation,
                'default',
                this.event.translation.translationsJSON[translation],
                true,
                false,
              )
            }
          }

          this.loadingAdditionalData = false
        }
      },
    },
    getEventNumOfRemainingTickets: {
      query: GET_EVENT_NUM_OF_REMAINING_TICKETS,
      variables() {
        return {
          eventId: this.event.id,
        }
      },
      manual: true, // This query will be triggered manually
      skip() {
        const isNonTicketingEvent =
          this.event && this.event.extraModules && !this.event.extraModules.ticketing

        return (
          this.isWaitingRoomCheckInProgress ||
          this.waitingRoomStatus === 'WAITING_ROOM' ||
          this.isEventUnavailable ||
          isNonTicketingEvent
        )
      },
      async result({ loading, data }) {
        if (!loading && data) {
          this.numberOfRemainingTickets = data.getEventNumOfRemainingTickets
          this.hasNoRemainingTickets = this.numberOfRemainingTickets <= 0
        }
      },
    },
  },
  beforeDestroy() {
    window.removeEventListener('pagehide', this.handlePageHide)
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
    if (this.checkoutHeartbeatInterval) {
      clearInterval(this.checkoutHeartbeatInterval)
    }
    if (this.requestTimeout) {
      clearTimeout(this.requestTimeout)
    }
  },
  methods: {
    scrollToLoginOptions() {
      if (this.$refs.checkoutRef) {
        this.$refs.checkoutRef.scrollToLoginOptions()
      }
    },
    getPromoCodeValue(promoCode) {
      return ((promoCode && (promoCode.code || promoCode.name)) || '').trim().toUpperCase()
    },
    isSpecialAutoPromoCode(promoCode) {
      return this.getPromoCodeValue(promoCode) === 'GDEAGC2026'
    },
    async handleAutoPromoCodeForOrganization625() {
      if (!this.isAutoPromoCodeEvent) {
        return
      }
      const minimumTicketAmount = 4
      const hasEnoughTickets = this.shoppingCart.length >= minimumTicketAmount
      const hasSpecialPromoApplied = this.isSpecialAutoPromoCode(this.promoCode)

      if (!hasEnoughTickets) {
        if (hasSpecialPromoApplied) {
          this.removePromoCode()
        }

        return
      }

      if (hasSpecialPromoApplied || this.promoCode || this.autoPromoCodeInProgress) {
        return
      }

      this.autoPromoCodeInProgress = true
      try {
        const { data, errors } = await getPromoCodeByName('GDEAGC2026', parseInt(this.event.id))
        if (errors || !data || !data.getPromoCodeByName) {
          return
        }

        this.promoCode = data.getPromoCodeByName
      } finally {
        this.autoPromoCodeInProgress = false
      }
    },
    handlePageHide() {
      if (this.guestId) {
        this.performCheckOut()
      }
    },
    async processSavedOrderAndOtherInitializations() {
      this.initialPromoCode = this.$route.query.promo
      const item = await this.parseSavedOrder()

      if (item && item[0]) {
        const [savedOrder, startedAt] = item

        this.order = savedOrder
        this.activeStep = 2

        const form = await initializeRegisterForm(savedOrder)
        this.form = form[0]
        this.shoppingCart = form[1]
        this.startTime = new Date(startedAt)
        const purchaseWithPromoCode = this.order.purchases.find(p => p.promoCode)
        if (purchaseWithPromoCode) {
          this.initialPromoCode = purchaseWithPromoCode.promoCode.code
        }
      }
      if (this.event.venueId && this.event.extraModules.floorPlan && this.order) {
        this.initialSeatSelect = await fetchSelectedSeatsByOrderUUID(this.order.uuid)
        this.selectedSeat([this.shoppingCart, [...this.initialSeatSelect.purchases]])
      }

      if (this.event.extraModules.workshops) {
        await this.getWorkshopDetails()
      }
    },
    async handleWaitingRoomCheck() {
      this.isWaitingRoomCheckInProgress = true
      let guestId = sessionStorage.getItem('guestId')
      const cachedStatusRaw = sessionStorage.getItem('waitingRoomInfo')

      if (cachedStatusRaw) {
        const cachedStatus = JSON.parse(cachedStatusRaw)
        const now = Date.now()
        // Trust cached status for 95s (slightly > poll interval) to avoid needless check-ins on refresh.
        if (cachedStatus && now - cachedStatus.timestamp < 95000) {
          this.guestId = guestId
          this.waitingRoomStatus = cachedStatus.status
          this.isWaitingRoomCheckInProgress = false

          if (this.waitingRoomStatus === 'WAITING_ROOM') {
            // Already in waiting room, just start polling for status updates.
            this.loadingAdditionalData = false
            this.loadingDynamicData = false
            this.startPolling()
          } else if (this.waitingRoomStatus === 'OK') {
            // Have a confirmed spot, load the page data and start heartbeating.
            this.startCheckoutHeartbeat()
            try {
              await this.$apollo.query({
                query: GET_EVENT_DYNAMIC_DATA,
                variables: { slug: this.eventSlug },
                fetchPolicy: 'no-cache',
              })
              await this.$apollo.query({
                query: GET_EVENT_ADDITIONAL_DATA_FOR_REGISTER_CONTAINER,
                variables: { slug: this.eventSlug },
                fetchPolicy: 'cache-first',
              })
              await this.processSavedOrderAndOtherInitializations()
            } catch (e) {
              console.error(
                'Failed to fetch event data after cached check-in, entering passive waiting room',
                e,
              )
              this.waitingRoomStatus = 'WAITING_ROOM'
              this.loadingDynamicData = false
              this.loadingAdditionalData = false
            }
          }

          return
        }
      }

      try {
        const response = await axios.post(
          `${serverURL}/register/check-in`,
          {
            guestId,
          },
          { withCredentials: true },
        )
        const { status, guestId: newGuestId, positionInQueue, peopleInFront } = response.data

        this.guestId = newGuestId
        sessionStorage.setItem('guestId', newGuestId)
        sessionStorage.setItem('waitingRoomInfo', JSON.stringify({ status, timestamp: Date.now() }))
        this.waitingRoomStatus = status
        this.positionInQueue = positionInQueue
        this.peopleInFront = peopleInFront

        if (status === 'WAITING_ROOM' || response.status > 400 || !response.data) {
          this.loadingAdditionalData = false
          this.loadingDynamicData = false
          this.startPolling()
        } else {
          // Not in waiting room, start sending heartbeats immediately to hold the checkout slot
          this.startCheckoutHeartbeat()
          // Now fetch remaining data
          try {
            await this.$apollo.queries.getEventBasicData.refetch()
            await this.$apollo.query({
              query: GET_EVENT_ADDITIONAL_DATA_FOR_REGISTER_CONTAINER,
              variables: { slug: this.eventSlug },
              fetchPolicy: 'cache-first',
            })
            await this.processSavedOrderAndOtherInitializations()
          } catch (e) {
            console.error(
              'Failed to fetch event data after check-in, entering passive waiting room',
              e,
            )
            this.waitingRoomStatus = 'WAITING_ROOM'
            this.loadingDynamicData = false
            this.loadingAdditionalData = false
          }
        }
      } catch (error) {
        // If the backend is down, we go into a "passive" waiting room state and start polling.
        console.error('Error during waiting room check-in:', error)
        this.waitingRoomStatus = 'WAITING_ROOM'
        this.loadingAdditionalData = false
        this.loadingDynamicData = false
        this.startPolling()
      } finally {
        this.isWaitingRoomCheckInProgress = false
      }
    },
    async pollStatus() {
      try {
        const statusResponse = await axios.get(
          `${serverURL}/register/status?guestId=${this.guestId}`,
          { withCredentials: true },
        )
        const { status, positionInQueue, peopleInFront } = statusResponse.data
        this.positionInQueue = positionInQueue
        this.peopleInFront = peopleInFront

        if (status === 'OK') {
          this.waitingRoomStatus = 'OK'
          clearInterval(this.pollingInterval)
          this.pollingInterval = null // Clear interval ID
          try {
            // User is out of the waiting room.
            // Start the heartbeat and fetch the data that was deferred.
            this.startCheckoutHeartbeat()
            await this.$apollo.queries.getEventBasicData.refetch()
            await this.$apollo.query({
              query: GET_EVENT_ADDITIONAL_DATA_FOR_REGISTER_CONTAINER,
              variables: { slug: this.eventSlug },
              fetchPolicy: 'cache-first',
            })
            await this.processSavedOrderAndOtherInitializations()
          } catch (e) {
            console.error('Failed to refetch data after leaving waiting room, re-entering', e)
            this.waitingRoomStatus = 'WAITING_ROOM'
            this.startPolling() // re-start polling
          }
        } else if (status === 'WAITING_ROOM') {
          // While in the waiting room, send a heartbeat
          await axios.post(
            `${serverURL}/register/heartbeat`,
            {
              guestId: this.guestId,
            },
            { withCredentials: true },
          )
        }
      } catch (error) {
        console.error('Error polling status or sending heartbeat, staying in waiting room:', error)
        this.waitingRoomStatus = 'WAITING_ROOM'
      }
    },
    startPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval)
      }
      // Poll immediately then start the interval
      this.pollStatus()
      this.pollingInterval = setInterval(this.pollStatus, 90000)
    },
    async performCheckOut() {
      try {
        const url = `${serverURL}/register/check-out`
        const data = JSON.stringify({ guestId: this.guestId })

        if (navigator.sendBeacon) {
          const blob = new Blob([data], { type: 'application/json' })
          navigator.sendBeacon(url, blob)
        } else {
          // Fallback for older browsers
          await axios.post(url, { guestId: this.guestId }, { withCredentials: true })
        }
        sessionStorage.removeItem('guestId')
      } catch (error) {
        console.error('Error during check-out:', error)
      }
    },
    showPromoCodeInputInRegisterContainer,
    sendOrganizationPageView() {
      if (this.organizationPageViewSent) {
        return
      }

      const pixelId =
        this.event && this.event.organization ? this.event.organization.metaPixelId : null
      const fired = sendOrganizationFacebookPageView(pixelId)

      if (fired) {
        this.organizationPageViewSent = true
      }
    },
    async sendOrganizationBeginCheckoutPixel(order) {
      try {
        await sendOrganizationFacebookPixelEvent({
          pixelId:
            this.event && this.event.organization ? this.event.organization.metaPixelId : null,
          eventName: 'InitiateCheckout',
          price: order && order.price,
          orderUuid: order && order.uuid,
          eventId: this.event && this.event.id,
        })
      } catch (error) {
        console.warn('Failed to send organization InitiateCheckout pixel', error)
      }
    },
    handlePaymentClick() {
      if (!this.$refs.checkoutRef) return

      this.$refs.checkoutRef.triggerButtonClick()
    },
    handleMembershipClick(membershipNumber) {
      if (this.event.extraModules.floorPlan) {
        this.$refs.childFloor.triggerMembershipClick(membershipNumber)
      } else {
        this.$refs.childList.triggerMembershipClick(membershipNumber)
      }
    },
    handleRemoveMembershipZkm() {
      if (this.event.extraModules.floorPlan) {
        this.$refs.childFloor.removePromoCode()
      }
      this.shoppingCart = this.shoppingCart.filter(t => !t.membership)
      this.membership = null
    },
    handleClickInChildA() {
      if (this.$refs.childFloor) {
        this.$refs.childFloor.triggerButtonClick()
      } else if (this.$refs.childList) {
        this.isZkm ? this.$refs.childList.triggerButtonClick() : this.onTicketsSelected()
      }
    },
    async clearTicketCart() {
      if (!this.event.venueId) {
        this.subscription = []
        if (!this.isZkm && this.event.cover) {
          this.$refs.addPromoCodeRef.removePromoCode()
        } else {
          this.$refs.cardHeaderRef.$refs.addPromoCodeRef.removePromoCode()
        }
        this.shoppingCart = []
        this.membership = null
        this.promoCode = null
        this.order = null
        localStorage.removeItem('order')
        this.activeStep = 1
      } else {
        this.initialSeatSelect = await fetchSelectedSeatsByOrderUUID(this.order.uuid)
        this.activeStep = 1
      }
      this.giftCard = null
      this.ticketsInsurance = false
    },
    async parseSavedOrder() {
      const savedOrder = localStorage.getItem('order')
      if (!savedOrder) {
        return null
      }
      const order = JSON.parse(savedOrder)
      const { orderUUID, startedAt, eventId } = order
      if (eventId !== this.event.id) {
        return null
      }
      const differenceInMinutes = moment(new Date()).diff(moment(startedAt), 'minutes')
      if (differenceInMinutes >= 15 && !isRevolutCheckoutActive()) {
        localStorage.removeItem('order')

        return null
      }
      const found = await getOrderInfoByUUID(orderUUID)

      return [found, startedAt]
    },
    updateAttendeFieldsForRikonEvent() {
      if (!this.schema || !this.schema.attendeeFields) {
        return
      }

      const shouldFieldBeDisplayed =
        this.shoppingCart &&
        this.shoppingCart.some(item => ['25854', '25855', '25856'].includes(String(item.id)))
      const field = this.schema.attendeeFields.find(field =>
        ['Veličina majice/hudice', 'Size-Veličina tshirt/hoodie'].includes(field.key),
      )
      if (!field) {
        return
      }
      this.$set(field, 'isPrivate', !shouldFieldBeDisplayed)
      this.$set(field, 'hidden', !shouldFieldBeDisplayed)
    },
    isMembershipTicketLimitError(message) {
      return [
        'User has already used a membership for this event!',
        'User selected too many membership tickets for this event.',
      ].includes(message)
    },
    async onTicketsSelected() {
      if (this.requiredTicketsPerCategory) {
        const selection = evaluateCategoryTicketPackages(
          this.$refs.childList.categories.map(([categoryId]) => categoryId),
          this.shoppingCart,
          this.requiredTicketsPerCategory,
          this.maxTicketPackages,
        )

        if (selection.status === 'invalid') {
          this.showError = true
          this.snackbarMessage = this.$t('selectCategoryTicketPackage')

          return
        }

        if (selection.status === 'limit') {
          this.showError = true
          this.snackbarMessage = this.$t('maxCategoryTicketPackages', {
            maxPackages: this.maxTicketPackages,
          })

          return
        }

        if (selection.status === 'incomplete') {
          this.showError = true
          this.snackbarMessage = this.$t('missingCategoryPackageTickets', {
            count: selection.missing,
          })

          return
        }
      }

      //TODO REMOVE MEMBERSHIP IF NO MEMBERSHIP TICKETS ARE SELECTED
      const variables = {
        eventId: this.event.id,
        attendees: this.shoppingCart.map(s => ({
          fields: { ticketId: s.id, bundleOfferId: s.bundleOfferId },
        })),
        workshopIds: [],
        referralName: this.referralName,
        promoCodeId: this.promoCode ? this.promoCode.id : null,
        membershipUserCode: this.membership ? Number(this.membership.code) : null,
        subscriptions: this.subscription,
        buyer: { fields: {} },
        price: this.totalPrice(),
      }
      const response = await createPurchaseAccreditationsPublic(variables)
      if (response && !response.errors) {
        const {
          data: {
            createPurchaseAccreditationsPublic: { quantityPerOrderItem, createdOrder },
          },
        } = response
        if (this.event && this.event.id === '8443') {
          this.updateAttendeFieldsForRikonEvent()
        }
        if (quantityPerOrderItem) {
          this.showError = true
          this.snackbarMessage = this.$t('wrongTicketQuantity')
          this.updatedOrderItems = quantityPerOrderItem

          return
        }
        localStorage.setItem(
          'order',
          JSON.stringify({
            orderUUID: createdOrder.uuid,
            startedAt: new Date(),
            eventId: this.event.id,
          }),
        )
        this.startTime = new Date()
        this.activeStep = 2
        this.order = await getOrderInfoByUUID(createdOrder.uuid)
        await this.sendOrganizationBeginCheckoutPixel(this.order || createdOrder)
        this.startCheckoutHeartbeat()
      } else {
        this.showBecomeMemberAlert =
          response.errors[0].message === 'User does not have a membership!' ||
          this.isMembershipTicketLimitError(response.errors[0].message)
        if (this.showBecomeMemberAlert) {
          this.shoppingCart = this.shoppingCart.filter(s => !s.itemMeta.sportMembershipTicket)
          this.$refs.childList.triggerRemoveSportMembershipTicket()
          this.becomeMemberMessage = response.errors[0].message

          return
        }
        this.showError = true

        const bundleOfferErrors = [
          'Bundle offer exceeded',
          'Bundle offer not found',
          'Bundle offer is not active',
        ]
        if (bundleOfferErrors.includes(response.errors[0].message)) {
          this.snackbarMessage = response.errors[0].message

          return
        }

        this.snackbarMessage = this.event.eventTemplateId
          ? response.errors[0].message
          : 'Promijenite narudžbu. Karte su već rezervirane.'
      }
    },
    async onFloorPlanSeatSelect(selectedSeats) {
      const localStorageOrder = this.parseSavedOrder()
      const attendeePurchasePublicData = {
        attendees: this.shoppingCart.map(s => ({
          fields: { ticketId: s.id, bundleOfferId: s.bundleOfferId },
        })),
        selectedSeats: selectedSeats,
        referralName: this.referralName,
        membershipUserCode: this.membership ? Number(this.membership.code) : null,
        subscriptions: this.subscription,
        orderUUID: localStorageOrder && localStorageOrder.orderUUID,
        promoCode: this.promoCode ? this.promoCode.id : null,
        buyer: { fields: {} },
        price: this.totalPrice(),
      }
      const response = await createFloorPlanPurchaseAccreditationsPublic({
        eventId: this.event.id,
        attendeePurchasePublicData,
      })

      if (response && !response.errors) {
        const {
          data: {
            createFloorPlanPurchaseAccreditationsPublic: { createdOrder, quantityPerOrderItem },
          },
        } = response
        if (quantityPerOrderItem) {
          this.showError = true
          this.snackbarMessage = this.$t('wrongTicketQuantity')
          this.updatedOrderItems = quantityPerOrderItem

          return
        }
        localStorage.setItem(
          'order',
          JSON.stringify({
            orderUUID: createdOrder.uuid,
            startedAt: new Date(),
            eventId: this.event.id,
          }),
        )
        this.startTime = new Date()
        this.activeStep = 2
        this.order = await getOrderInfoByUUID(createdOrder.uuid)
        await this.sendOrganizationBeginCheckoutPixel(this.order || createdOrder)
        this.startCheckoutHeartbeat()

        return
      } else {
        if (this.isMembershipTicketLimitError(response.errors[0].message)) {
          this.showBecomeMemberAlert = true
          this.becomeMemberMessage = response.errors[0].message

          return
        }

        this.showError = true
        this.snackbarMessage =
          response.errors[0].message || 'Promijenite narudžbu. Sjedala su već rezervirana.'
      }
    },
    async createAttendee({ attendee, workshops }, skipReset = false) {
      const { category: categoryId, ...fields } = attendee
      const variables = {
        eventId: this.event.id,
        attendee: {
          fields,
          categoryId,
        },
        workshopIds: workshops,
        referralName: this.referralName,
        ticketingEnabled: false,
      }
      const response = await createPendingAccreditationPublic(variables)
      if (skipReset) return response

      if (response && !response.errors) {
        this.showMessage = true
      } else {
        this.form.workshops = []
        this.showError = true
        this.snackbarMessage = response.errors[0].message
      }
      await Promise.all([
        this.$apollo.queries.getEventDetailsForRegisterContainer.refetch(),
        this.$apollo.queries.getEventAttendeeCapacity.refetch(),
      ])
    },
    async submitStepper() {
      await this.createAttendee(this.form)
    },
    async next(data) {
      this.form.attendee = data

      const checkIfAttendeeAlreadyExists =
        [2444, 2341, 4531, 8265].includes(Number(this.event.id)) && (await this.checkAttendeeExists())
      if (checkIfAttendeeAlreadyExists) {
        this.errorMessage =
          Number(this.event.id) === 8265
            ? 'Sudionik s ovim imenom, prezimenom i ustanovom već je prijavljen za događaj. Molimo obratite se organizatoru.'
            : 'Sudionik s ovim imenom i prezimenom već je prijavljen za događaj. Molimo obratite se organizatoru.'
        this.snackbarOpen = true

        return
      }

      this.activeStep = this.event.extraModules.workshops ? 4 : this.submitStepper()
    },
    async checkAttendeeExists() {
      const { data } = await this.$apollo.query({
        query: CHECK_IF_ATTENDEE_ALREADY_EXISTS,
        variables: {
          eventId: this.event.id,
          attendee: {
            email: this.form.attendee.Email,
            firstName: this.form.attendee['First name'].trim(),
            lastName: this.form.attendee['Last name'].trim(),
            institution: this.form.attendee['Tvrtka/ustanova'],
          },
        },
      })

      return data.checkIfAttendeeAlreadyExistsOnEvent
    },
    async getWorkshopDetails() {
      const { data } = await this.$apollo.query({
        query: GET_WORKSHOP_DETAILS_BY_EVENT_SLUG,
        variables: {
          slug: this.eventSlug,
        },
      })

      return (this.event = { ...this.event, ...data.getWorkshopDetailsByEventSlug })
    },
    getLanguageCodeFromQueryParams() {
      const params = new URL(window.location.href).searchParams

      return params.get('lang')
    },
    cinehillPackageRemainingMessage(count) {
      return this.$t(
        count === 1 ? 'cinehillPackageOneTicketRemaining' : 'cinehillPackageTicketsRemaining',
        { count },
      )
    },
    async purchaseTicket(paymentType) {
      if (isRevolutCheckoutActive()) return
      try {
        await this.submitPurchaseTicket(paymentType)
      } catch (error) {
        this.errorMessage = this.$t('paymentCheckoutError')
        this.snackbarOpen = true
      } finally {
        if (this.$refs.checkoutRef) this.$refs.checkoutRef.$data.disabledSubmitButton = false
        if (this.$refs.ticketPriceList) this.$refs.ticketPriceList.$data.disabledSubmitButton = false
      }
    },
    async submitPurchaseTicket(paymentType) {
      if (isRevolutCheckoutActive()) return
      if (this.totalPriceNum() > 0 && !paymentType) return
      this.$refs.checkoutRef.$data.disabledSubmitButton = true
      this.$refs.ticketPriceList.$data.disabledSubmitButton = true

      const timeDiff = moment.duration(moment().diff(moment(this.startTime)))
      if (timeDiff.asMinutes() >= 15) {
        localStorage.removeItem('order')
        window.location.reload()

        return
      }
      const {
        attendee: { tickets, insurance, ticketOwners, ...rest },
      } = this.form
      const attendeeTickets = tickets || []
      rest.getOrganizerSubscription = rest.getSubscription || false
      const { purchases } = this.order
      let legalEntity = null
      if (rest.r1Invoice) {
        legalEntity = {
          name: rest.legalEntityName,
          OIB: rest.legalEntityOIB,
          address: rest.legalEntityAddress,
          zipCode: rest.legalEntityZipcode,
          city: rest.legalEntityCity,
          country: rest.legalEntityCountry,
          contactName: '',
          email: rest.legalEntityEmail,
          phone: '',
        }
      }
      const {
        'First name': firstName,
        'Last name': lastName,
        Email: email,
        ...remainingFields
      } = rest
      const ticketOwnerMetaFields = [
        'ticketId',
        'ticketName',
        'firstName',
        'lastName',
        'email',
        'sameAsBuyer',
        'sendTicketToOwner',
        'sendTicketToOwnerTouched',
        // attached separately below, so it never rides along as a ticket-owner field
        '__disabilityCardNumber',
      ]
      const getTicketOwnerFields = ticketOwner =>
        Object.entries(ticketOwner || {}).reduce((acc, [key, value]) => {
          if (
            !ticketOwnerMetaFields.includes(key) &&
            !BUYER_FIELD_KEYS_WITH_PERSONALIZATION.includes(key)
          ) {
            acc[key] = value
          }

          return acc
        }, {})
      const personalizedAttendeeFieldKeys = this.hasTicketPersonalization
        ? (this.schema.attendeeFields || [])
          .map(field => field.key)
          .filter(key => !BUYER_FIELD_KEYS_WITH_PERSONALIZATION.includes(key))
        : []
      const buyerRemainingFields = this.hasTicketPersonalization
        ? Object.entries(remainingFields).reduce((acc, [key, value]) => {
          if (!personalizedAttendeeFieldKeys.includes(key)) {
            acc[key] = value
          }

          return acc
        }, {})
        : remainingFields
      const sameAsBuyerTicketIndex = this.hasTicketPersonalization
        ? attendeeTickets.findIndex(ticket => ticket && ticket.sameAsBuyer)
        : -1
      // the card number belongs to one specific accessible ticket, so pair the entries to the
      // purchases by order item rather than trusting both arrays to be in the same order
      const unclaimedCardNumbers = attendeeTickets
        .filter(ticket => ticket && ticket.__disabilityCardNumber)
        .map(ticket => ({
          ticketId: ticket.ticketId,
          cardNumber: ticket.__disabilityCardNumber,
        }))
      const cardNumberPerPurchase = purchases.map(p => {
        const orderItemId = p.orderItem && p.orderItem.id
        const match = unclaimedCardNumbers.findIndex(
          entry => String(entry.ticketId) === String(orderItemId),
        )

        return match === -1 ? null : unclaimedCardNumbers.splice(match, 1)[0].cardNumber
      })
      const variables = {
        eventId: this.event.id,
        orderId: this.order.id,
        buyer: {
          fields: {
            firstName,
            lastName,
            email,
            ...buyerRemainingFields,
          },
        },
        attendees: purchases.map((p, index) => {
          const ticketOwner = this.hasTicketPersonalization
            ? attendeeTickets[index] || (ticketOwners && ticketOwners[index]) || {}
            : {}
          const ticketOwnerFields = getTicketOwnerFields(ticketOwner)
          const canUseBuyerFields =
            this.hasTicketPersonalization &&
            ticketOwner.sameAsBuyer &&
            index === sameAsBuyerTicketIndex
          const ownerFirstName = canUseBuyerFields
            ? firstName
            : ticketOwner.firstName || (!this.hasTicketPersonalization ? firstName : '')
          const ownerLastName = canUseBuyerFields
            ? lastName
            : ticketOwner.lastName || (!this.hasTicketPersonalization ? lastName : '')
          const ownerEmail = canUseBuyerFields
            ? email
            : ticketOwner.email || (!this.hasTicketPersonalization ? email : '')

          return {
            fields: {
              'First name': ownerFirstName,
              'Last name': ownerLastName,
              Email: ownerEmail,
              ...(this.hasTicketPersonalization ? ticketOwnerFields : remainingFields),
              ...(this.hasTicketPersonalization
                ? { __sendTicketToOwner: !!ticketOwner.sendTicketToOwner }
                : {}),
              // required for accessible tickets, printed on the ticket PDF only
              ...(cardNumberPerPurchase[index]
                ? { __disabilityCardNumber: cardNumberPerPurchase[index] }
                : {}),
              //custom fields for event.id = 2445 - delete when event is over
              ...(Number(this.event.id) === 2445
                ? { Function: rest.function, 'Company/organization name': rest.companyOrganization }
                : {}),
            },
            id: p.attendeeId,
          }
        }),
        legalEntity,
        lang: this.getLanguageCodeFromQueryParams(),
        ticketInsurance: !!insurance && insurance.selected,
      }

      const { data, errors } = await populateOrderData(variables)
      if (!data) {
        this.$refs.checkoutRef.$data.disabledSubmitButton = false
        this.$refs.ticketPriceList.$data.disabledSubmitButton = false

        if (errors) {
          //custom feat for futsal dinamo
          const notMember =
            errors[0].message ===
            'Ticket sales are currently available only to users with a membership.'
          const userAllTickets =
            errors[0].message ===
            'You have already purchased the maximum number of membership tickets for your account.'
          if (notMember) {
            this.userMessageDialog = {
              btnText: 'Postani član',
              btnLink:
                'https://app.core-event.co/organization/futsal-dinamo-ab77/sport-memberships-store',
              title: 'Još nisi član?',
              description:
                'Trenutno je u tijeku prodaja ulaznica za članove, a regularna prodaja počet će 17.03.2024. Kako biste osigurali svoju ulaznicu, pozivamo vas da postanete član i iskoristite prednost rane kupnje. Više informacija i mogućnost kupnje članstva možete pronaći na sljedećem linku:',
              target: '_blank',
            }
            this.showUserMessageDialog = true

            return
          }
          if (userAllTickets) {
            this.userMessageDialog = {
              title: 'Obavijest',
              description:
                'Iskoristili ste kupnju svih ulaznica uključenih u vaše članstvo. Za dodatne ulaznice morat ćete pričekati otvaranje regularne prodaje.',
              btnText: 'Razumijem',
              btnLink: 'https://www.core-event.co',
              target: '_self',
            }
            this.showUserMessageDialog = true

            return
          }
        }
        this.errorMessage = 'Error in populating order data. Try again later.'
        this.snackbarOpen = true

        return
      }

      localStorage.removeItem('order')
      await this.performCheckOut()
      this.stopCheckoutHeartbeat()

      if (this.totalPriceNum() === 0) {
        return this.$router.push({
          name: 'successful-payment',
          params: { orderUUID: this.order.uuid, lang: this.getLanguageCodeFromQueryParams() },
        })
      }
      if (paymentType === 'KulturnaIskaznica') {
        window.location.href = getKiPaymentRedirectUrl(this.order.id, this.order.uuid)

        return
      }

      try {
        this.form.paymentMethod = paymentType
        const checkout = await createPurchaseCheckout(
          this.form,
          this.totalPrice(),
          this.order,
          i18next.language,
          this.shoppingCart,
          this.event.id,
        )
        await startPaymentCheckout(checkout)
      } catch (error) {
        // A rejected checkout used to leave the purchase button disabled with
        // no visible feedback. Let the buyer retry and expose the provider's
        // reason instead of making the flow appear unresponsive.
        console.error('Unable to start payment checkout:', error)
        this.$refs.checkoutRef.$data.disabledSubmitButton = false
        this.$refs.ticketPriceList.$data.disabledSubmitButton = false
        this.errorMessage =
          (error && error.response && error.response.data && error.response.data.message) ||
          (error && error.message) ||
          'Payment checkout could not be started. Please try again.'
        this.snackbarOpen = true
      }
    },
    async submitAttendee() {
      await this.createAttendee({ attendee: this.form })
      this.showMessage = true
      this.$v.$reset()
      await this.$router.replace({ query: undefined })
    },
    async submitForm() {
      return submitGuard(this, this.submitAttendee)
    },
    selectedTickets(tickets) {
      this.shoppingCart = tickets
    },
    removeExistingLocation(seatInfo) {
      const [currTicket, seatLocation, _, oldTicket] = seatInfo
      const [section, row, seat] = seatLocation.split('_')
      const existingLocation = this.ticketLocations[oldTicket.id].find(
        location => location['section'] === section && location['row'] === row,
      )
      existingLocation.seats.splice(existingLocation.seats.indexOf(seat.split('-')[1]), 1)
      !existingLocation.seats.length &&
        this.ticketLocations[oldTicket.id].splice(
          this.ticketLocations[oldTicket.id].indexOf(existingLocation),
          1,
        )
      if (this.ticketLocations[oldTicket.id] && !this.ticketLocations[oldTicket.id].length) {
        delete this.ticketLocations[oldTicket.id]
      }
    },
    removeSelectedSeat(seatInfo) {
      const [currTicket, seatLocation, seatHasSameColorAsCurrTicket, oldTicket, suppressReticket] =
        seatInfo
      this.removeExistingLocation(seatInfo)
      let ticketIndex = this.shoppingCart.findIndex(
        oi =>
          oi.id === oldTicket.id &&
          (oi.bundleOfferId || null) === ((oldTicket && oldTicket.bundleOfferId) || null),
      )
      if (ticketIndex === -1) {
        ticketIndex = this.shoppingCart.findIndex(oi => oi.id === oldTicket.id)
      }
      if (ticketIndex !== -1) {
        this.shoppingCart.splice(ticketIndex, 1)
      }
      if (this.event.eventTemplateId && !seatHasSameColorAsCurrTicket && !suppressReticket) {
        this.addSelectedSeat([currTicket, seatLocation])
      }
    },
    removeSelectedTableTickets(seatInfo) {
      const [ticket, seatLocation, seatHasSameColorAsCurrTicket, oldTicket, tableDetails] = seatInfo
      this.removeExistingLocation(seatInfo)
      let ticketsToRemove = tableDetails[seatLocation]
      for (let idx = this.shoppingCart.length - 1; idx >= 0 && ticketsToRemove > 0; idx--) {
        if (this.shoppingCart[idx].id === ticket.id) {
          this.shoppingCart.splice(idx, 1)
          ticketsToRemove--
        }
      }
      this.replaceShoppingCartTicketsForOrderItem(
        ticket,
        this.shoppingCart.filter(oi => oi.id === ticket.id).length,
      )
    },
    addSelectedSeat(seatInfo) {
      const [ticket, seatLocation] = seatInfo
      !!seatLocation && this.insertNewSeat(ticket, seatLocation)
      this.shoppingCart.push(ticket)
    },
    addDialogElementToOrder(ticketInfo) {
      const [ticket, quantity, type, location, options = {}] = ticketInfo
      if (type === TicketType.TABLE) {
        this.insertNewSeat(ticket, location)

        if (typeof options.totalQuantityForTicketId === 'number') {
          return this.replaceShoppingCartTicketsForOrderItem(
            ticket,
            options.totalQuantityForTicketId,
          )
        }
      } else if (typeof options.totalQuantityForTicketId === 'number') {
        return this.replaceShoppingCartTicketsForOrderItem(ticket, options.totalQuantityForTicketId)
      }

      this.shoppingCart = this.shoppingCart.filter(t => t.id !== ticket.id)
      for (let i = 0; i < quantity; i++) {
        this.shoppingCart.push(ticket)
      }
    },
    buildShoppingCartBundleTickets(ticket, quantity) {
      const adjustedQuantity = quantity
      if (!ticket || adjustedQuantity <= 0) {
        return []
      }

      const bundleOffer = ticket.bundleOffer
      if (!bundleOffer || bundleOffer.availableQuantity <= 0) {
        return Array.from({ length: adjustedQuantity }, () => ticket)
      }

      const quantityInterval = Number(bundleOffer.quantityInterval)
      const freeQuantity = Number(bundleOffer.freeQuantity)
      const availableQuantity = Number(bundleOffer.availableQuantity)
      const bundleSize = quantityInterval + freeQuantity

      if (!quantityInterval || !freeQuantity || !bundleSize || !availableQuantity) {
        return Array.from({ length: adjustedQuantity }, () => ticket)
      }

      const bundleCoveredQuantity = Math.min(adjustedQuantity, bundleSize * availableQuantity)
      const fullBundles = Math.floor(bundleCoveredQuantity / bundleSize)
      const remainder = bundleCoveredQuantity % bundleSize
      const freeCount = fullBundles * freeQuantity + Math.max(remainder - quantityInterval, 0)
      const paidCount = Math.max(adjustedQuantity - freeCount, 0)

      return [
        ...Array.from({ length: paidCount }, () => ticket),
        ...Array.from({ length: freeCount }, () => ({
          ...ticket,
          price: 0,
          bundleOfferId: bundleOffer.id,
        })),
      ]
    },
    replaceShoppingCartTicketsForOrderItem(ticket, quantity) {
      this.shoppingCart = [
        ...this.shoppingCart.filter(t => t.id !== ticket.id),
        ...this.buildShoppingCartBundleTickets(ticket, quantity),
      ]
    },
    insertNewSeat(ticket, seatLocation) {
      const isTable = ticket.itemMeta && ticket.itemMeta.table
      const [section, row, seat] = seatLocation.split('_')
      if (!this.ticketLocations[ticket.id]) {
        return (this.ticketLocations[ticket.id] = [
          {
            section: section,
            row: row,
            seats: [seat.split('-')[1]],
            isTable,
          },
        ])
      }
      const existingLocation = this.ticketLocations[ticket.id].find(
        location => location['section'] === section && location['row'] === row,
      )
      if (existingLocation) {
        return (existingLocation.seats = [...existingLocation.seats, seat.split('-')[1]])
      }
      this.ticketLocations[ticket.id] = [
        ...this.ticketLocations[ticket.id],
        {
          section: section,
          row: row,
          seats: [seat.split('-')[1]],
          isTable,
        },
      ]
    },
    selectedSeat(seatInfo) {
      const [ticket, purchases] = seatInfo
      purchases.map(p => {
        !p.orderItem.itemMeta.parter &&
          this.insertNewSeat(p.orderItem, p.accreditation.ticketLocation)
      })
    },
    addAnother() {
      this.form = {}
      this.activeStep = 1
      this.showMessage = false
    },
    applyPromoCode(promoCodeInput) {
      const minimumTicketAmount = 4
      if (
        this.isAutoPromoCodeEvent &&
        this.isSpecialAutoPromoCode(promoCodeInput) &&
        this.shoppingCart.length < minimumTicketAmount
      ) {
        this.errorMessage = 'You need to select at least 4 tickets to apply this promo code.'
        this.snackbarOpen = true

        return
      }

      this.promoCode = promoCodeInput
    },
    applyMembership(membership) {
      this.membership = membership
    },
    applyOrderItemAccessCode(accessCode) {
      this.orderItemAccessCode = accessCode
    },
    applySubscription(subscription) {
      this.subscription.push(subscription)
    },
    removeSubscription() {
      this.subscription = []
    },
    removePromoCode() {
      this.promoCode = null
    },
    totalPriceNum() {
      return this.$refs.ticketPriceList.calculateTotalPrice()
    },
    totalPrice() {
      return this.$refs.ticketPriceList.getTotalPrice()
    },
    goBack() {
      this.$router.push({
        name: 'event-public',
        params: { slug: this.event.slug },
      })
    },
    applyGiftCard(giftCardData) {
      this.giftCard = giftCardData
    },
    redirectToDefaultBrowser() {
      const currUrl = window.location.href
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        const iosVersion = getIOSVersion(navigator.userAgent)
        if (!iosVersion) {
          return
        }
        window.location.href = `${
          iosVersion < 17 ? 'com-apple-mobilesafari-tab:' : 'x-safari-'
        }${currUrl}`
      } else if (/Android/i.test(navigator.userAgent)) {
        window.location.href = `intent://${currUrl.replace(/^https?:\/\//, '')}#Intent;scheme=http${
          currUrl.includes('https://') ? 's' : ''
        };action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(
          currUrl,
        )};end`
      }
    },
    removePromoCodeAndMembership() {
      this.handleRemoveMembershipZkm()
      this.removePromoCode()
      this.handleRemoveOrderItemAccessCode()
    },
    handleRemoveOrderItemAccessCode() {
      this.orderItemAccessCode = null
    },
    startCheckoutHeartbeat() {
      this.stopCheckoutHeartbeat() // Ensure no multiple intervals are running
      this.checkoutHeartbeatInterval = setInterval(async () => {
        if (this.guestId) {
          try {
            await axios.post(
              `${serverURL}/register/heartbeat`,
              {
                guestId: this.guestId,
              },
              { withCredentials: true },
            )
          } catch (error) {
            console.error('Error sending checkout heartbeat:', error)
          }
        }
      }, 60000) // Send heartbeat every 60 seconds
    },
    stopCheckoutHeartbeat() {
      if (this.checkoutHeartbeatInterval) {
        clearInterval(this.checkoutHeartbeatInterval)
        this.checkoutHeartbeatInterval = null
      }
    },
  },
}
</script>

<style scoped>
.container {
  min-height: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.container > .event-password-unavailable {
  margin: auto;
  transform: translateY(-24px);
}

.card-header-container {
  margin-bottom: 48px;
}

.event-cover {
  background-size: cover;
  border-radius: 8px 8px 0 0;
  font-size: 0;
  display: flex;
}

@supports not (aspect-ratio: 16/9) {
  .event-cover {
    position: relative;
    height: 0;
    padding-top: 33.33333%;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.event-cover img {
  aspect-ratio: 16/9;
  object-fit: cover;
  width: 100%;
  border-radius: 8px 8px 0 0;
}

.cover-header-noTicket {
  margin: 150px 0 0 50px;
  height: auto;
}

.cover-header-style-zkm-border {
  border-bottom: none;
}

.my-page-title {
  font-family: Raleway, serif;
  font-style: normal;
  font-weight: bold;
  text-align: center;
  font-size: 38px;
  line-height: 45px;
  color: #ff4c00;
  margin-bottom: 24px;
  margin-top: 60px;
}

.description {
  font-family: Source Sans Pro, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  color: #333333;
}

.card-header-container {
  margin-bottom: 48px;
}

.registration-success-page {
  max-width: 640px !important;
  align-items: center;
  margin: 120px 20px 0 20px;
  display: flex;
  flex-direction: column;
}

.info-image {
  width: 100%;
}

.ticket-list-container {
  margin-right: 30px;
}

.ticket-list-container-with-cover {
  @media screen and (min-width: 801px) and (max-width: 1000px) {
    margin-left: 1.5rem;
  }
}

.grid-container::before {
  content: '';
  grid-row: 1/-1;
}

.grid-container {
  max-width: 1440px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 366px) minmax(50%, 692px) minmax(25%, 366px);
  grid-template-rows: min-content min-content max-content;
}

.event-cover {
  grid-column: 3;
  grid-row: 1;
}

.overflow-card {
  grid-column: 3;
}

.cover-header-style {
  grid-column: 3;
}

main {
  grid-column: 2 / 3;
  grid-row: 1 / 10;
}

.main-no-image {
  grid-column: 2 / 3;
}

.main-no-image-zkm {
  grid-column: 1 / 3;
}

@media screen and (max-width: 992px) and (min-width: 801px) {
  .main-no-image {
    margin: 0 1.5rem;
  }
}

@media screen and (max-width: 992px) {
  .event-cover {
    display: none !important;
    grid-column: 1;
  }

  .register-layout {
    flex-direction: column-reverse;
  }

  .cover-header-noTicket {
    margin: 0;
  }

  .grid-container {
    grid-template-columns: 1fr;

    @media screen and (max-width: 1000px) {
      display: unset;
    }
  }

  .overflow-card {
    grid-column: 1;
    grid-row: 1;
  }

  main {
    grid-column: 1;
    grid-row: 2;
  }

  .main-no-image {
    grid-column: 1;
    grid-row: 2;
  }

  .cover-header-style {
    margin: 0;
    grid-column: 1;
  }

  .ticket-list-container {
    margin-right: 0;
  }
}

@media screen and (max-width: 375px) {
  .cover-header-style-zkm {
    width: unset;
    margin: 0 auto;
  }
}

.no-tickets {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;
}

.no-tickets img {
  margin: 64px 0;
}

.checkout-timer-regular {
  margin-right: 1.5rem;
  max-width: 389px;
}

@media screen and (max-width: 992px) {
  .checkout-timer-regular {
    display: none;
  }
}

@media screen and (max-width: 1000px) {
  .checkout-timer-regular-mobile,
  .checkout-timer-regular-mobile-no-cover {
    margin: -1rem -1.5rem 0 -1.5rem;
    position: fixed;
    width: 100%;
    border-left: unset;
    border-right: unset;
    border-radius: unset;
    z-index: 1;
  }
}

.checkout-timer-regular-mobile {
  @media screen and (min-width: 993px) {
    display: none;
  }
  @media screen and (max-width: 425px) {
    margin-top: -11.5rem;
    top: 231px;
  }
  @media screen and (max-width: 800px) and (min-width: 426px) {
    margin-top: -10.75rem;
    top: 252px;
  }
  @media screen and (max-width: 992px) and (min-width: 801px) {
    margin-top: -10.5rem;
    top: 248px;
  }
}

.checkout-timer-regular-mobile-no-cover {
  @media screen and (min-width: 993px) {
    display: none;
  }
  @media screen and (max-width: 425px) {
    margin-top: -11.5rem;
    top: 231px;
  }
  @media screen and (max-width: 800px) and (min-width: 426px) {
    margin-top: -10.75rem;
    top: 252px;
  }
  @media screen and (max-width: 992px) and (min-width: 801px) {
    margin-top: -12.25rem;
    top: 276px;
  }
}

.promo-code-container {
  padding-top: 1.5rem;
  border-radius: 0.25rem;
  border: 1px solid var(--stroke-one, rgba(151, 151, 151, 0.5));
  margin-top: 1.5rem;
  @media screen and (max-width: 800px) and (min-width: 600px) {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
  @media screen and (max-width: 1000px) {
    border: unset;
  }
}

.event-cover,
.overflow-card-step-two {
  @media screen and (max-width: 992px) {
    display: none;
  }
}

.card-header-with-cover {
  @media screen and (min-width: 993px) {
    margin-right: 1.5rem;
  }
}
</style>
